export const nanToUndefined = (v: any) => (isNaN(v) ? undefined : v);
export const handleClearedAutocomplete = (v: number, orig: any) =>
  orig === '' || orig === null ? null : v;
